import { takeEvery, put, call } from "redux-saga/effects"
import { GET_DASHBOARD_INFO, GET_DASHBOARD_INFO_FILTER, GET_MEDIAN_AVERAGE_INFO } from "./actionTypes"
import {
  getDashboardInfoSuccess,
  getDashboardInfoFail,
  getMedianAndAverageSuccess,
  getMedianAndAverageFail,
  showLoading, 
  hideLoading
} from "./actions"
import { getDashboardInfo, getDashboardInfoFilter, calculateMedianAverage } from "../../helpers/backend_helper"

function* fetchDashboardInfo({ payload: id }) {
  try {
    yield put(showLoading(true))
    const response = yield call(getDashboardInfo, id)
    yield put(getDashboardInfoSuccess(response))
    yield put(hideLoading(false))
  } catch (error) {
    yield put(showLoading(true))
    yield put(getDashboardInfoFail(error))
  }
}

function* fetchDashboardInfoFilter({ payload: id }) {
  try {
    yield put(showLoading(true));
    const response = yield call(getDashboardInfoFilter, id);
    yield put(getDashboardInfoSuccess(response));
    yield put(hideLoading(false));
  } catch (error) {
    yield put(hideLoading(false));
    yield put(getDashboardInfoFail(error));
  }
}

function* fetchMedianAverageInfo({ payload: id }) {
  try {
    const response = yield call(calculateMedianAverage, id)
    yield put(getMedianAndAverageSuccess(response))
  } catch (error) {
    yield put(getMedianAndAverageFail(error))
  }
}
function* dashboardSaga() {
  yield takeEvery(GET_DASHBOARD_INFO, fetchDashboardInfo)
  yield takeEvery(GET_DASHBOARD_INFO_FILTER, fetchDashboardInfoFilter)
  yield takeEvery(GET_MEDIAN_AVERAGE_INFO, fetchMedianAverageInfo)
}

export default dashboardSaga
